<template>
  <div>
    <div class="modal-body" style="min-height: 500px;">
      <!-- Alert di Bootstrap visibile sopra -->
      <div class="alert alert-warning d-flex align-items-center mb-3" role="alert">
        <i class="ph-warning me-2"></i>
        <div>
          🚧 La gestione delle modifiche ai PDF è in fase di sviluppo. <br />
          🪦 Qui giace <strong>Germano Anselmi</strong>, il programmatore più forte al mondo,che per la prima volta ha fallito...per ora...
        </div>
      </div>

      <!-- Iframe del PDF -->
      <iframe
        :src="pdfUrl"
        style="width: 100%; height: 80vh; border: none;"
      ></iframe>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="$emit('close')">Chiudi</button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({ file: Object })

const pdfUrl = computed(() => {
  return `${utils.BASE_API}ftp/get-pdf?path=${encodeURIComponent(props.file?.fullPath || '')}`
})
</script>



<!-- <template>
  <div>
    <div class="modal-body" style="min-height: 500px;">
      <div class="pdf-editor-wrapper">
        <div class="viewer-container" ref="viewerContainer">
          <div
            v-for="(page, index) in pages"
            :key="index"
            class="page-wrapper"
            @click="(e) => handleOverlayClick(e, index)"
          >
            <canvas :ref="el => canvasRefs[index] = el" class="pdf-canvas" />

            <div
              v-for="(layer, lIndex) in layers.filter(l => l.page === index)"
              :key="lIndex"
              class="annotation"
              :style="{
                top: layer.y + 'px',
                left: layer.x + 'px',
                width: layer.width + 'px',
                height: layer.height + 'px'
              }"
            >
              {{ layer.text }}
            </div>
          </div>
          <textarea
            v-if="isAddingText && hasClicked"
            ref="editingInput"
            v-model="editingText"
            class="annotation-input"
            :style="{
              top: editingPos.y + 'px',
              left: editingPos.x + 'px',
              width: editingSize.width + 'px',
              height: editingSize.height + 'px'
            }"
            @blur="finalizeLayer"
          />
        </div>

        <div class="toolbar mt-2 text-center">
          <button class="btn btn-sm btn-primary" @click="enableAddText">➕ Aggiungi nota</button>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="$emit('close')">Chiudi</button>
      <button class="btn btn-primary" @click="savePdf">💾 Salva</button>
    </div>
  </div>
</template> -->

<!-- <script setup>
import { ref, reactive, watch, nextTick } from 'vue'
import { getDocument, GlobalWorkerOptions } from 'pdfjs-dist'
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.js?url'

GlobalWorkerOptions.workerSrc = workerSrc

const props = defineProps({ file: Object })
const emit = defineEmits(['update:pdf'])

const viewerContainer = ref(null)
const editingInput = ref(null)
const canvasRefs = reactive([])
const pages = ref([])

const layers = ref([])
const editingText = ref('')
const editingPos = ref({ x: 0, y: 0 })
const editingSize = ref({ width: 120, height: 40 })

const isAddingText = ref(false)
const hasClicked = ref(false)
const scale = ref(1.5)
const activePage = ref(0)

watch(() => props.file, async (file) => {
  if (file?.fullPath) {
    const baseApi = 'http://localhost/dryland_2/CORE/SERVER/API/'
    const url = `${baseApi}/ftp/get-pdf?path=${encodeURIComponent(file.fullPath)}`

    try {
      const loadingTask = getDocument(url)
      const pdfDoc = await loadingTask.promise

      pages.value = new Array(pdfDoc.numPages).fill(null)
      canvasRefs.length = pdfDoc.numPages

      for (let i = 0; i < pdfDoc.numPages; i++) {
        const page = await pdfDoc.getPage(i + 1)
        const viewport = page.getViewport({ scale: scale.value })

        await nextTick()
        const canvas = canvasRefs[i]
        const ctx = canvas.getContext('2d')
        canvas.height = viewport.height
        canvas.width = viewport.width

        await page.render({ canvasContext: ctx, viewport }).promise
      }

      layers.value = []
    } catch (err) {
      console.error('Errore nel caricamento PDF:', err)
    }
  }
})

function enableAddText() {
  isAddingText.value = true
  hasClicked.value = false
}

function handleOverlayClick(e, pageIndex) {
  if (!isAddingText.value || hasClicked.value) return

  const canvas = canvasRefs[pageIndex]
  const rect = canvas.getBoundingClientRect()

  const scaleX = canvas.width / rect.width
  const scaleY = canvas.height / rect.height

  const x = (e.clientX - rect.left) * scaleX
  const y = (e.clientY - rect.top) * scaleY

  editingPos.value = { x, y }
  activePage.value = pageIndex
  editingText.value = ''
  hasClicked.value = true

  nextTick(() => editingInput.value?.focus())
}

function finalizeLayer() {
  if (!editingText.value.trim()) return

  layers.value.push({
  x: editingPos.value.x,
  y: editingPos.value.y,
  width: editingSize.value.width,
  height: editingSize.value.height,
  text: editingText.value.trim(),
  page: activePage.value,
  pagePixelWidth: canvasRefs[activePage.value].width,
  pagePixelHeight: canvasRefs[activePage.value].height
})


  isAddingText.value = false
  editingText.value = ''
  hasClicked.value = false
}

function savePdf() {
  if (isAddingText.value && editingText.value.trim()) finalizeLayer()

  utils.ajax('ftp/save-pdf-overlay', {
    path: props.file.fullPath,
    layers: layers.value,
    scale: scale.value
  }, res => {
    if (res.esito === 0) {
      console.log(' PDF aggiornato con successo', res.file)
      emit('update:pdf', res.file)
    } else {
      console.error(res.messaggio || 'Errore durante il salvataggio')
    }
  })
}
</script> -->

<!-- <style scoped>
.viewer-container {
  position: relative;
  overflow: auto;
  max-height: 80vh;
  border: 1px solid #ccc;
}
.page-wrapper {
  position: relative;
  margin-bottom: 20px;
}
.pdf-canvas {
  display: block;
  width: 100%;
  height: auto;
}
.annotation {
  position: absolute;
  background: rgba(255, 255, 0, 0.6);
  border: 1px solid #333;
  padding: 4px;
  font-size: 12px;
  white-space: pre-wrap;
  pointer-events: none;
}
.annotation-input {
  position: absolute;
  border: 1px dashed #555;
  background: rgba(255, 255, 255, 0.7);
  resize: both;
  overflow: auto;
  font-size: 12px;
  padding: 4px;
  outline: none;
  min-width: 60px;
  min-height: 30px;
  z-index: 999;
}
</style> -->
